import { FC, useReducer, ChangeEvent, useEffect } from 'react';
import { Container, Dealerships } from './MyDataDealer.styles';
import { Button, Input, Section, DealerCard } from '../../../../components';
import { SaveOutlined } from '@mui/icons-material';
import { useToastStore, useUserStore } from '../../../../stores';
import { Form, SectionTitle, Separator } from '../../MyAccount.styles';
import { dealerDataInitialState, dealerDataReducer } from './forms/dealerData.form';
import { TUser, TUserUpdate, putUser } from '../../../../services';

const MyDataDealer: FC = () => {
	const { user, setUser } = useUserStore();
	const { setToast } = useToastStore();

	const [dealerDataState, dealerDataDispatch] = useReducer(
		dealerDataReducer,
		dealerDataInitialState
	);

	const handleDealerDataInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
		const { name, value } = e.target;
		dealerDataDispatch({ type: 'SET_FIELD_VALUE', field: name, payload: value });
	};

	const handleUpdateBasicData = async () => {
		const newUserData: TUser = {
			...user!,
			nome: dealerDataState.nome,
			email: dealerDataState.email,
			telefone: dealerDataState.telefone,
		};
		const body: TUserUpdate = {
			id: user?.id || 0,
			nome: dealerDataState.nome,
			email: dealerDataState.email,
			telefone: dealerDataState.telefone,
		};

		try {
			await putUser(body);
			setUser(newUserData);
			setToast({ message: 'Dados atualizados com sucesso!', variant: 'success' });
		} catch {
			setToast({ message: 'Erro ao atualizar dados!', variant: 'error' });
		}
	};

	useEffect(() => {
		if (!user) return;

		const newShopkeeperState = { nome: user.nome, telefone: user.telefone, email: user.email };
		dealerDataDispatch({ type: 'REPLACE_STATE', payload: newShopkeeperState });
	}, [user]);

	return (
		<Container>
			<Section>
				<SectionTitle>Meus dados</SectionTitle>
				<Separator />
				<Form>
					<Input
						variant='text'
						label='Nome'
						className='full-line'
						value={dealerDataState.nome}
						name='nome'
						onChange={handleDealerDataInputChange}
					/>
					<Input
						variant='text'
						label='Login/E-mail'
						className='left-half'
						value={dealerDataState.email}
						name='email'
						onChange={handleDealerDataInputChange}
					/>
					<Input
						variant='text'
						label='Telefone'
						className='right-half'
						value={dealerDataState.telefone}
						name='telefone'
						onChange={handleDealerDataInputChange}
					/>
					<Button
						variant='contained'
						onClick={handleUpdateBasicData}
						fitContent
						disabled={!dealerDataState.nome || !dealerDataState.email || !dealerDataState.telefone}
					>
						<SaveOutlined fontSize='medium' />
						<span>Salvar</span>
					</Button>
				</Form>
			</Section>
			<Section>
				<SectionTitle>Concessionárias relacionadas</SectionTitle>
				<Separator />
				<Dealerships>
					{user?.concessionarias?.map((concessionaria) => (
						<DealerCard key={concessionaria.id} dealerData={concessionaria} />
					))}
				</Dealerships>
			</Section>
		</Container>
	);
};

export default MyDataDealer;
